export const GUT_INFORMIERT_LINKS = {
  MIX_PRICE_LIST: 'link_mix_pricelist'
} as const;

export const EMPTY_PLACEHOLDER = '#empty#';
export const REGEX_CONDITIONS = {
  PLACEHOLDER_BRACKET: /{{(.*?)}}/gi
};

export const IMAGE_FETCH_PRIORITY = {
  High: 'high',
  Low: 'low',
  Auto: 'auto'
} as const;

export const INTERNATIONAL_DOMAIN = 'www.pixum.com';

export const PNG_MEDIA_RESOURCES: Record<string, string> = {
  appstore_huawei: 'images/footer/appstore_huawei-de.png',
  delivery_correos: 'images/footer/delivery_correos.png',
  delivery_bpost: 'images/footer/delivery_bpost.png',
  delivery_laposte: 'images/footer/delivery_laposte.png',
  delivery_post_at: 'images/footer/delivery_post_at.png',
  delivery_ups: 'images/footer/delivery_ups.png',
  delivery_royalmail: 'images/footer/delivery_royalmail.png',
  delivery_post_nl: 'images/footer/delivery_post_nl.png',
  delivery_tipsa: 'images/footer/delivery_tipsa.png',
  delivery_postnord: 'images/footer/delivery_postnord.png',
  delivery_brt: 'images/footer/delivery_brt.png',
  payment_ae: 'images/footer/payment_ae@2x.png',
  payment_postepay: 'images/footer/payment_postepay@2x.png',
  payment_mastercard: 'images/footer/payment_mastercard.png',
  payment_dankort: 'images/footer/payment_dankort.png',
  payment_maestro: 'images/footer/payment_maestro.png',
  payment_visa: 'images/footer/payment_visa.png',
  payment_invoice: 'images/footer/payment_invoice@2x.png',
  payment_invoice_be_nl: 'images/footer/payment_invoice_BENL@2x.png',
  payment_sepa: 'images/footer/payment_sepa.png',
  payment_sepa_lastschrift: 'images/footer/payment_sepa-lastschrift@2x.png',
  payment_sepa_factur: 'images/footer/payment_sepa_factur@2x.png',
  secure_confianza: 'images/footer/secure_confianza.png',
  secure_becom: 'images/footer/secure_becom.png',
  social_facebook: 'images/footer/social_facebook.png',
  social_instagram: 'images/footer/social_instagram.png',
  social_pinterest: 'images/footer/social_pinterest.png',
  social_youtube: 'images/footer/social_youtube.png',
  'delivery_colis-prive': 'images/footer/delivery_colis-prive.png',
  appstore_apple: 'images/footer/appstore_apple-de.png',
  'appstore_apple-de': 'images/footer/appstore_apple-de.png',
  'appstore_apple-sv': 'images/footer/appstore_apple-se.png',
  'appstore_apple-es': 'images/footer/appstore_apple-es.png',
  'appstore_apple-da': 'images/footer/appstore_apple-dk.png',
  'appstore_apple-en': 'images/footer/appstore_apple-en.png',
  'appstore_apple-it': 'images/footer/appstore_apple-it.png',
  'appstore_apple-fr': 'images/footer/appstore_apple-fr.png',
  'appstore_apple-nl': 'images/footer/appstore_apple-nl.png',
  download_fotowelt_macos: 'images/footer/download_fotowelt_macos-de.png',
  'download_fotowelt_macos-de': 'images/footer/download_fotowelt_macos-de.png',
  'download_fotowelt_macos-sv': 'images/footer/download_fotowelt_macos-sv.png',
  'download_fotowelt_macos-es': 'images/footer/download_fotowelt_macos-es.png',
  'download_fotowelt_macos-fr': 'images/footer/download_fotowelt_macos-fr.png',
  'download_fotowelt_macos-da': 'images/footer/download_fotowelt_macos-dk.png',
  'download_fotowelt_macos-nl': 'images/footer/download_fotowelt_macos-nl.png',
  'download_fotowelt_macos-en': 'images/footer/download_fotowelt_macos-en.png',
  'download_fotowelt_macos-it': 'images/footer/download_fotowelt_macos-it.png',
  download_fotowelt_win: 'images/footer/download_fotowelt_win-de.png',
  'download_fotowelt_win-de': 'images/footer/download_fotowelt_win-de.png',
  'download_fotowelt_win-es': 'images/footer/download_fotowelt_win-es.png',
  'download_fotowelt_win-da': 'images/footer/download_fotowelt_win-dk.png',
  'download_fotowelt_win-it': 'images/footer/download_fotowelt_win-it.png',
  'download_fotowelt_win-en': 'images/footer/download_fotowelt_win-en.png',
  'download_fotowelt_win-sv': 'images/footer/download_fotowelt_win-sv.png',
  'download_fotowelt_win-fr': 'images/footer/download_fotowelt_win-fr.png',
  'download_fotowelt_win-nl': 'images/footer/download_fotowelt_win-nl.png',
  appstore_google: 'images/footer/appstore_google-de.png',
  'appstore_google-de': 'images/footer/appstore_google-de.png',
  'appstore_google-es': 'images/footer/appstore_google-es.png',
  'appstore_google-sv': 'images/footer/appstore_google-se.png',
  'appstore_google-it': 'images/footer/appstore_google-it.png',
  'appstore_google-da': 'images/footer/appstore_google-dk.png',
  'appstore_google-fr': 'images/footer/appstore_google-fr.png',
  'appstore_google-en': 'images/footer/appstore_google-en.png',
  'appstore_google-nl': 'images/footer/appstore_google-nl.png'
};

export const ICON_HEIGHTS = {
  mastercard: 55,
  appstore: 40,
  default: 35
};

export const BRAND_BAR_OPTIONS = {
  open: 'open',
  close: 'close'
};

export const CDN_HOST = 'https://cdn.pixum.com';

export const LINK_NODE_INTERNAL_NAME = {
  Logout: 'link_logout'
};

export const PAGE_PATH = {
  RootStartPage: '/',
  Service: '/service',
  CartOverview: '/cart'
};

export const CLIENT_SIDE_STORAGE_KEYS = {
  SHOW_APP_BANNER: 'showAppBanner'
};

export const KEYVISUAL_TYPE = {
  CLASSIC: 'Classic',
  HIGH_CONTRAST: 'High-Contrast',
  HIGH_CONTRAST_WITH_AWARDS: 'High-Contrast with Awards',
  HIGHLIGHT: 'Highlight',
  BLOG: 'Blog',
  MAGAZINE: 'MagazineKeyVisual',
  DOWNLOAD: 'Download'
} as const;

export const WEB_HEADER_VARIANTS = {
  DEFAULT: 'default',
  SLIM: 'slim'
} as const;

export const PIXUM_VOUCHER_CODE_STORAGE_KEY = 'PIXUM_CART_VOUCHER' as const;
export const REVIEW_SECTION_ID = 'reviews' as const;
export const CUSTOMER_SUPPORT_SECTION_ID = 'customer-support' as const;

export const CUSTOM_JAVASCRIPT_TYPE = {
  MODULE: 'module',
  CLASSIC: 'classic'
} as const;

export const DIALOG_TYPE = {
  DEFAULT: 'DEFAULT',
  ORDER_WAYS: 'ORDER_WAYS',
  SOFTWARE_DOWNLOAD: 'SOFTWARE_DOWNLOAD'
} as const;

// VideoNode carries no dimensions, so the ratio is fixed to the one the YouTube iframe renders at.
export const MAGAZINE_VIDEO_ASPECT_RATIO = '16 / 9';
